import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useGoodsReceiptOverview } from "./GoodsReceiptOverviewContext";

const LinesTab = () => {
  const { goodsReceipt: record } = useGoodsReceiptOverview();
  if (!record) return null;

  return (
    <Row>
      <Col>
        <Card>
          <CardBody>
            <div className="text-muted">
              <h6 className="mb-3 text-uppercase">Lines</h6>
              <div className="table-responsive">
                <table className="table table-sm align-middle mb-0">
                  <thead>
                    <tr>
                      <th>Product</th>
                      <th className="text-end">Qty received</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(record.items ?? []).map((ln, i) => (
                      <tr key={ln.id ?? i}>
                        <td>
                          {ln.product?.name ??
                            (ln.productId != null
                              ? `Product #${ln.productId}`
                              : "—")}
                        </td>
                        <td className="text-end tabular-nums">
                          {ln.quantityReceived ?? "—"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default LinesTab;
